import { render, staticRenderFns } from "./AproconHeader.vue?vue&type=template&id=8fb28d2e&"
import script from "./AproconHeader.vue?vue&type=script&lang=ts&"
export * from "./AproconHeader.vue?vue&type=script&lang=ts&"
import style0 from "../assets/css/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports